<div class="position-relative overflow-hidden h-100 d-flex flex-column">
    <div class="flex-grow-1 overflow-hidden">
        <dx-data-grid
            id="storageUnitHistoryGrid"
            class="grid theme-dependent"
            keyExpr="id"
            [dataSource]="historyData"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>

            <dxo-toolbar>
                <dxi-item location="before"><div class="grid-header">Bin History</div></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton" [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton" [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('binNumber')" caption="Storage Bin" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('zone')" caption="Zone" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" caption="Date Updated" dataType="datetime" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('duration')" caption="Duration" dataType="number" [minWidth]="100" alignment="left"></dxi-column>
            <dxi-column [dataField]="gridFieldName('storageTypeCode')" caption="Storage Type" [minWidth]="120"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="120" cellTemplate="statusTemplate"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" caption="Date Entered" dataType="datetime" [minWidth]="150" sortOrder="desc"></dxi-column>

            <div *dxTemplate="let cellInfo of 'statusTemplate'">
                 <span class="badge" [class]="getStatusBadgeClass(cellInfo.value)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>

